import { Stack } from "@mui/material";
import { CommitteeRoleItem } from "./CommitteeRoleItem";
import { KeyRole } from "../../types/apiTypes";
import { useAppSelector } from "../../hooks";
import { selectPermissions } from "../../features/permissionsSlice";
import { TierAccordion } from "./TierAccordion";
import { useMemo, useState } from "react";
import { RolesTierType } from "../../types/enums";

type Props = {
  campaign_id: string;
  key_roles: KeyRole[];
};

export const RolesList = ({ campaign_id, key_roles }: Props) => {
  const [expandedTier, setExpandedTier] = useState<string>(
    RolesTierType.authority,
  );

  const { isAllowedEditActionsTargetTitles } =
    useAppSelector(selectPermissions);

  const expandHandler = (tier: string) => {
    setExpandedTier(tier === expandedTier ? "" : tier);
  };

  const prepareRoles = useMemo(() => {
    const data: { -readonly [K in keyof typeof RolesTierType]?: KeyRole[] } =
      {};

    key_roles.forEach((role) => {
      (data[role.tier] ??= []).push(role);
    });

    return data;
  }, [key_roles]);

  return (
    <Stack sx={{ gap: "16px", width: "100%" }}>
      {Object.entries(prepareRoles).map(([key, value]) => (
        <TierAccordion
          key={key}
          isExpanded={
            RolesTierType[key as keyof typeof RolesTierType] === expandedTier
          }
          title={RolesTierType[key as keyof typeof RolesTierType]}
          onExpend={expandHandler}
        >
          <Stack sx={{ gap: "8px", width: "100%" }}>
            {value.map((role) => (
              <CommitteeRoleItem
                key={role.id}
                campaign_id={campaign_id}
                role={role}
                isEditor={!!isAllowedEditActionsTargetTitles}
              />
            ))}
          </Stack>
        </TierAccordion>
      ))}
    </Stack>
  );
};
